export const URL_NAME = 'Bargain Blocks';
export const APP_URL = 'https://www.bargain-blocks.com';
export const APP_VERSION = 0.2;
